<div class="ws-popup-content">
  <div class="contact-association-dialog">
    <div class="confirm-icon">
      <mat-icon>person_add</mat-icon>
    </div>
    
    <div class="confirm-message">
      {{ "This contact already exists" | translate }}
    </div>

    <div class="contact-info">
      <div class="contact-header">
        <strong class="full-name">
          {{!contact.firstName && !contact.lastName ? contact.companyName : contact.firstname}} {{contact.lastName || ''}}
        </strong>
        <strong class="country">
          {{getCountryByIso(contact.countryISO!) | translatable : 'name' : 'pascal'}}
          <ws-flag 
            [countryCode]="contact.countryISO"
            size="small"
            [showBorder]="true"
          ></ws-flag>
        </strong>
      </div>

      <div class="contact-details">
        <strong class="email">{{email}}</strong>
        <span class="phone">{{phone}}</span>
      </div>
    </div>

    <div class="confirm-question">
      {{ "Associate the reservation to this contact?" | translate }}
    </div>
  </div>
  
  <div class="ws-popup-footer">
    <span></span>
    <div class="actions-footer">
      <div class="confirm-buttons">
        <ws-button (click)="noClicked()" [callToActionType]="'tertiary'">
          {{ "No" | translate }}
        </ws-button>
        <ws-button (click)="yesClicked()" [callToActionType]="'primary'">
          {{ "Yes" | translate }}
        </ws-button>
      </div>
    </div>
  </div>
</div>
